var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.705 1.365 16.639 6.3l-.884.883-3.425-3.424v14.69h-1.25V3.758L7.655 7.182 6.77 6.3l4.934-4.934Zm-4.438 9.373H4.14L.76 23.125h21.887L19.27 10.738h-3.128v1.25h2.173l2.697 9.887H2.398l2.697-9.887h2.172v-1.25Z",
    fill: "currentColor"
  })));
};
export default SvgUpload;